import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let calendar_date_user = new BaseTableModule('/ws/calendar_date_user/');

const state = {
    ...calendar_date_user.state,
    columns: [
        {text: 'Calendar date', value: 'calendar_date__dt', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Human user', value: 'human_user__employee_number', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Staff contract', value: 'staff_contract', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Work', value: 'work', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Work tracker', value: 'work_tracker', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Pause', value: 'pause', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Sick', value: 'sick', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Vacation', value: 'vacation', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Max possible', value: 'max_possible', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Plan', value: 'plan', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Events', value: 'event_type_array', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'Error', value: 'error', sortable: true, filterable: true, divider: true, brief: true,},
    ],
    columns_contract_execution: [
        {text: 'Start week date', value: 'calendar_date__start_week_date', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Human user', value: 'human_user__user', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Work', value: 'work_sum', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Work tracker', value: 'work_tracker_sum', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Plan', value: 'plan_sum', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Up work', value: 'up_work_sum', sortable: false, filterable: true, divider: true, brief: true,},
    ],
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['-id'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
    },
    local_phrase: {
        tracker: {en: 'tracker', de: 'Tracker', color: 'blue darken-1', class: 'timer'},
        working: {en: 'working', de: 'Arbeit', color: 'blue darken-1', class: 'more_time'},
        work_kug: {en: 'work_kug', de: 'KUG', color: 'deep-purple darken-1', class: 'access_time'},
        pause: {en: 'pause', de: 'Zeitkorrektur', color: 'light-blue darken-1', class: 'pause_circle'},
        time_correction: {en: 'time correction', de: 'Zeitabzug', color: 'brown darken-1', class: 'timer_off'},
        time_add: {en: 'time add', de: 'Zeit-Plus', color: 'light-blue darken-1', class: 'add_alarm'},
        holiday: {en: 'holiday', de: 'Urlaub', color: 'green darken-1', class: 'beach_access'},
        holiday_extra: {en: 'holiday extra', de: 'Überstunden', color: 'green darken-1', class: 'home'},
        sick: {en: 'sick', de: 'Krank', color: 'amber darken-1', class: 'sick'},
        sick_with_child: {en: 'sick with child', de: 'Kind krank', color: 'amber darken-1', class: 'child_care'},
        sick_kug: {en: 'sick kug', de: 'KUG-Krank', color: 'orange darken-1', class: 'healing'},
    },

};
const getters = {
    ...calendar_date_user.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...calendar_date_user.actions,
};
const mutations = {
    ...calendar_date_user.mutations,
};

export default {
    modules: {
        CalendarDateUser: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}